import { KilopostsMaster } from '@/models/apis/master/masterResponse';
import { RoadNameDirectionShortcut, RoadNameDirectionMix } from '@/models/index';
import { GIKilopost } from '@/models/geoItem';
import { Kilopost } from '@/models/apis/device/adminDeviceResponse';

export function convKiloposts_(obfuscatedKpObj: KilopostsMaster): Map<string, Map<string, GIKilopost[]>> {
  const kps = deobfuscateKps(obfuscatedKpObj);
  const ret: Map<string, Map<string, GIKilopost[]>> = new Map();
  for (const kp of kps) {
    // 路線名、方向、本線/それ以外 でまとめる.
    // それ以外については、さらに場所名でまとめる.
    const k1 = `${kp.road_name}#${kp.direction}`;
    const k2 = kp.road_section_type === '1' ? 'main_line' : kp.place_name;
    if (!k2) { continue; }

    if (!ret.has(k1)) { ret.set(k1, new Map()); }
    const obj1 = ret.get(k1);
    if (obj1 !== undefined) {
      if (!obj1.has(k2)) { obj1.set(k2, []); }
      const arr = obj1.get(k2);
      const giKp: GIKilopost = {
        ...kp,
        kp: parseFloat(kp.kp),
        kp2: kp.kp2 ? parseInt(kp.kp2.toString()) : kp.kp2,
        kp_calc: parseFloat(kp.kp_calc),
        lat: parseFloat(kp.lat),
        lon: parseFloat(kp.lon),
        place_name_disp: kp.place_name === 'main_line' ? '' : kp.place_name,
      };
      if (arr !== undefined) { arr.push(giKp); }
    }
  }

  for (const ent1 of ret) {
    const obj1 = ent1[1];
    for (const [place, arr] of obj1) {
      if (place === 'main_line') {
        // 本線
        arr.sort((a: GIKilopost, b: GIKilopost) => {
          const v1 = a.kp_calc;
          const v2 = b.kp_calc;
          return v1 < v2 ? -1 : (v1 > v2 ? 1 : 0);
        });
      } else {
        // それ以外
        // (少なくとも今の所、road_section_typeが'1'以外だったら
        // place_nameに場所名が入っている)
        arr.sort((a: GIKilopost, b: GIKilopost) => {
          if (a.place_name < b.place_name) {
            return -1;
          } else if (a.place_name > b.place_name) {
            return 1;
          }
          return a.kp_calc < b.kp_calc ? -1 : (a.kp_calc > b.kp_calc ? 1 : 0);
        });
      }
    }
  }
  return ret;
}

function getVal(service: any, val: string, defaultVal: string): any {
  let ret = service[val];
  if (ret === undefined) { ret = service[defaultVal]; }
  return ret;
}

export function deobfuscateKps(origKpObj: KilopostsMaster): Kilopost[] {
  // サーバ側で短縮されているものを元に戻す.
  // property名、あとroad_nameとroad_name_disp.
  const kps = origKpObj.kiloposts;
  const kpValMap = origKpObj.kilopost_val_map;

  const results: Kilopost[] = [];
  kps.forEach(kp => {
    results.push({
      kp_uid: kp.a,
      road_name_disp: kpValMap['b'] ? kpValMap['b'][kp.b] : '',
      road_name: kpValMap['c'] ? kpValMap['c'][kp.c] : '',
      direction: kpValMap['d'] ? kpValMap['d'][kp.d] : kp.d,
      road_section_type: kpValMap['e'] ? kpValMap['e'][kp.e] : kp.e,
      place_name: kpValMap['f'] ? kpValMap['f'][kp.f] : kp.f,
      kp_prefix: kpValMap['g'] ? kpValMap['g'][kp.g] : kp.g,
      kp: kpValMap['h'] ? kpValMap['h'][kp.h] : kp.h,
      kp2: kpValMap['i'] ? kpValMap['i'][kp.i] : kp.i,
      kp_calc: kpValMap['j'] ? kpValMap['j'][kp.j] : kp.j,
      lat: kpValMap['k'] ? kpValMap['k'][kp.k] : kp.k,
      lon: kpValMap['l'] ? kpValMap['l'][kp.l] : kp.l,
      bikou1: kpValMap['m'] && kp.m ? kpValMap['m'][kp.m] : kp.m,
      kp_set_id: kpValMap['n'] ? kpValMap['n'][kp.n] : kp.n,
      kp_disp: kpValMap['o'] && kp.o ? kpValMap['o'][kp.o] : kp.o,
      angle: kpValMap['p'] ? kpValMap['p'][kp.p] : kp.p,
    });
  });

  return results;
}

// convKiloposts_で加工したものを引数にもらい、画面で利用する
// 路線名#方向の一覧を生成する、と思ったけどソート順とか考えるの
// めんどいから全部ベタ書きにする.
class RoadNameDirectionsService {
  get getRoadNameDirections_shutokou() {
    const srcArr = [
      ['t-west', 't-01ueno', '1号上野線', '上,下', '高速1号上野線'],
      ['t-west', 't-01haneda', '1号羽田線', '上,下', '高速1号羽田線'],
      ['t-west', 't-02meguro', '2号目黒線', '上,下', '高速2号目黒線'],
      ['t-west', 't-03shibuya', '3号渋谷線', '上,下', '高速3号渋谷線'],
      ['t-west', 't-04shinjuku', '4号新宿線', '上,下', '高速4号新宿線'],
      ['t-west', 't-05ikebukuro-W', '5号池袋線(西)', '上,下', '高速5号池袋線（東京西地区）'],
      ['t-east', 't-05ikebukuro-E', '5号池袋線(東)', '上,下', '高速5号池袋線（東京東地区）'],
      ['t-east', 't-06mukoujima', '6号向島線', '上,下', '高速6号向島線'],
      ['t-east', 't-06misato', '6号三郷線', '上,下', '高速6号三郷線'],
      ['t-east', 't-07komatsugawa', '7号小松川線', '上,下', '高速7号小松川線'],
      ['t-east', 't-09fukagawa', '9号深川線', '上,下', '高速9号深川線'],
      ['t-east', 't-10harumi', '10号晴海線', '上,下', '高速10号晴海線'],
      ['t-east', 't-11daiba', '11号台場線', '上,下', '高速11号台場線'],
      ['t-west', 't-yaesu', '八重洲線', '南,北', '高速八重洲線'],
      ['t-west', 't-tkan', '都心環状線', '内,外', '高速都心環状線'],
      ['t-west', 't-ckan-W', '中央環状線(西)', '内,外', '高速中央環状線（東京西地区）'],
      ['t-east', 't-ckan-E', '中央環状線(東)', '内,外', '高速中央環状線（東京東地区）'],
      ['dummy-hr1', '------------'],
      ['t-east', 's-kawaguchi', '川口線', '上,下', '高速川口線'],
      ['t-east', 's-ohmiya', '埼玉大宮線', '上,下', '高速埼玉大宮線'],
      ['t-east', 's-shintoshin', '埼玉新都心線', '上,下', '高速埼玉新都心線'],
      ['dummy-hr2', '------------'],
      ['kanagawa', 'k-01yokohane', '神1号横羽線', '上,下', '高速神奈川1号横羽線'],
      ['kanagawa', 'k-02mitsuzawa', '神2号三ツ沢線', '上,下', '高速神奈川2号三ツ沢線'],
      ['kanagawa', 'k-03kariba', '神3号狩場線', '上,下', '高速神奈川3号狩場線'],
      ['kanagawa', 'k-05daikoku', '神5号大黒線', '上,下', '高速神奈川5号大黒線'],
      ['kanagawa', 'k-06kawasaki', '神6号川崎線', '上,下', '高速神奈川6号川崎線'],
      ['kanagawa', 'k-07yokokita', '神7号横北線', '上,下', '高速神奈川7号横浜北線'],
      ['kanagawa', 'k-07yokohokusei', '神7号横北西線', '上,下', '高速神奈川7号横浜北西線'],
      ['dummy-hr3', '------------'],
      ['t-east', 'b-wangan-t', '湾岸線(東)', '西,東', '高速湾岸線（東京地区）'],
      ['kanagawa', 'b-wangan-k', '湾岸線(神)', '西,東', '高速湾岸線（神奈川地区）'],
    ];
    const ret: RoadNameDirectionMix[] = [];
    srcArr.forEach(e => {
      if (e[0].indexOf('dummy') !== 0) {
        const area = e[0];
        const roadName = e[1];
        const roadNameDisp = e[2];
        const roadNameReal = e[4];
        const directions = e[3].split(',').map(e => {
          return {
            direction: e,
            selected: false,
          };
        });
        ret.push({
          area,
          roadName,
          roadNameDisp,
          roadNameReal,
          directions,
          isDummy: false,
        });
      } else {
        ret.push({
          key: e[0],
          disp: e[1],
          isDummy: true,
        });
      }
    });
    return ret;
  }
  get getRoadNameDirections_hokuriku() {
    const srcArr = [
      ['area-all', 'R7', 'R7', '上,下', 'R7'],
      ['area-all', 'R7(新)', 'R7(新)', '上,下', 'R7(新)'],
      ['area-all', 'R8', 'R8', '上,下', 'R8'],
      ['area-all', 'R49', 'R49', '上,下', 'R49'],
      ['area-all', 'R113', 'R113', '上,下', 'R113'],
      ['area-all', 'R116', 'R116', '上,下', 'R116'],
    ];
    const ret: RoadNameDirectionMix[] = [];
    srcArr.forEach(e => {
      if (e[0].indexOf('dummy') !== 0) {
        const area = e[0];
        const roadName = e[1];
        const roadNameDisp = e[2];
        const roadNameReal = e[4];
        const directions = e[3].split(',').map(e => {
          return {
            direction: e,
            selected: false,
          };
        });
        ret.push({
          area,
          roadName,
          roadNameDisp,
          roadNameReal,
          directions,
          isDummy: false,
        });
      } else {
        ret.push({
          key: e[0],
          disp: e[1],
          isDummy: true,
        });
      }
    });
    return ret;
  }
  get getRoadNameDirections_arc() {
    const srcArr = [
      ['area-all', 'セントレアライン', 'セントレアライン', '上,下', 'R7'],
      ['area-all', '知多半島道路', '知多半島道路', '上,下', '知多半島道路'],
      ['area-all', '南知多道路', '南知多道路', '上,下', '南知多道路'],
    ];
    const ret: RoadNameDirectionMix[] = [];
    srcArr.forEach(e => {
      if (e[0].indexOf('dummy') !== 0) {
        const area = e[0];
        const roadName = e[1];
        const roadNameDisp = e[2];
        const roadNameReal = e[4];
        const directions = e[3].split(',').map(e => {
          return {
            direction: e,
            selected: false,
          };
        });
        ret.push({
          area,
          roadName,
          roadNameDisp,
          roadNameReal,
          directions,
          isDummy: false,
        });
      } else {
        ret.push({
          key: e[0],
          disp: e[1],
          isDummy: true,
        });
      }
    });
    return ret;
  }
  get getRoadNameDirections_shikoku() {
    const srcArr = [
      ['area-all', '高松．坂出支線', '高松．坂出支線', '上,下', '高松．坂出支線'],
      ['area-all', '高松自動車道', '高松自動車道', '上,下', '高松自動車道'],
      ['area-all', '高松東道路', '高松東道路', '上,下', '高松東道路'],
      ['area-all', '松山自動車道', '松山自動車道', '上,下', '松山自動車道'],
      ['area-all', '徳島自動車道', '徳島自動車道', '上,下', '徳島自動車道'],
      ['area-all', '高知自動車道', '高知自動車道', '上,下', '高知自動車道'],
    ];
    const ret: RoadNameDirectionMix[] = [];
    srcArr.forEach(e => {
      if (e[0].indexOf('dummy') !== 0) {
        const area = e[0];
        const roadName = e[1];
        const roadNameDisp = e[2];
        const roadNameReal = e[4];
        const directions = e[3].split(',').map(e => {
          return {
            direction: e,
            selected: false,
          };
        });
        ret.push({
          area,
          roadName,
          roadNameDisp,
          roadNameReal,
          directions,
          isDummy: false,
        });
      } else {
        ret.push({
          key: e[0],
          disp: e[1],
          isDummy: true,
        });
      }
    });
    return ret;
  }
  get getRoadNameDirections_fukuoka_kitakyushu() {
    const srcArr = [
      ['area-all', '1号線', '1号線', '上,下', '1号線'],
      ['area-all', '2号線', '2号線', '上,下', '2号線'],
      ['area-all', '3号線', '3号線', '上,下', '3号線'],
      ['area-all', '4号線', '4号線', '上,下', '4号線'],
      ['area-all', '5号線', '5号線', '上,下', '5号線'],
    ];
    const ret: RoadNameDirectionMix[] = [];
    srcArr.forEach(e => {
      if (e[0].indexOf('dummy') !== 0) {
        const area = e[0];
        const roadName = e[1];
        const roadNameDisp = e[2];
        const roadNameReal = e[4];
        const directions = e[3].split(',').map(e => {
          return {
            direction: e,
            selected: false,
          };
        });
        ret.push({
          area,
          roadName,
          roadNameDisp,
          roadNameReal,
          directions,
          isDummy: false,
        });
      } else {
        ret.push({
          key: e[0],
          disp: e[1],
          isDummy: true,
        });
      }
    });
    return ret;
  }
  get getRoadNameDirections_hiroshima_airport() {
    const srcArr = [
      ['area-all', 'RW', 'RW', '西,東', 'RW'],
      ['area-all', 'P', 'P', '西,東', 'P'],
      ['area-all', 'T1', 'T1', '南,北', 'T1'],
      ['area-all', 'T2', 'T2', '南,北', 'T2'],
      ['area-all', 'T3', 'T3', '南,北', 'T3'],
      ['area-all', 'T4', 'T4', '南,北', 'T4'],
      ['area-all', 'T5', 'T5', '南,北', 'T5'],
      ['area-all', 'T6', 'T6', '南,北', 'T6'],
      ['area-all', 'AP1', 'AP1', '西,東', 'AP1'],
      ['area-all', 'AP2', 'AP2', '西,東', 'AP2'],
    ];
    const ret: RoadNameDirectionMix[] = [];
    srcArr.forEach(e => {
      if (e[0].indexOf('dummy') !== 0) {
        const area = e[0];
        const roadName = e[1];
        const roadNameDisp = e[2];
        const roadNameReal = e[4];
        const directions = e[3].split(',').map(e => {
          return {
            direction: e,
            selected: false,
          };
        });
        ret.push({
          area,
          roadName,
          roadNameDisp,
          roadNameReal,
          directions,
          isDummy: false,
        });
      } else {
        ret.push({
          key: e[0],
          disp: e[1],
          isDummy: true,
        });
      }
    });
    return ret;
  }
  get getRoadNameDirections_shinchitose_airport() {
    const srcArr = [
      ['area-all', 'SC-A-RWY-1', 'SC-A-RWY-1', '上,下', 'SC-A-RWY-1'],
      ['area-all', 'SC-A-RWY-2', 'SC-A-RWY-2', '上,下', 'SC-A-RWY-2'],
      ['area-all', 'SC-A-RWY-3', 'SC-A-RWY-3', '上,下', 'SC-A-RWY-3'],
      ['area-all', 'SC-B-RWY-1', 'SC-B-RWY-1', '上,下', 'SC-B-RWY-1'],
      ['area-all', 'SC-B-RWY-2', 'SC-B-RWY-2', '上,下', 'SC-B-RWY-2'],
      ['area-all', 'SC-B-RWY-3', 'SC-B-RWY-3', '上,下', 'SC-B-RWY-3'],
      ['area-all', 'SC-D01-1', 'SC-D01-1', '上,下', 'SC-D01-1'],
      ['area-all', 'SC-D01-2', 'SC-D01-2', '上,下', 'SC-D01-2'],
      ['area-all', 'SC-D02-1', 'SC-D02-1', '上,下', 'SC-D02-1'],
      ['area-all', 'SC-D02-2', 'SC-D02-2', '上,下', 'SC-D02-2'],
      ['area-all', 'SC-D03-1', 'SC-D03-1', '上,下', 'SC-D03-1'],
      ['area-all', 'SC-D03-2', 'SC-D03-2', '上,下', 'SC-D03-2'],
      ['area-all', 'SC-D04-1', 'SC-D04-1', '上,下', 'SC-D04-1'],
      ['area-all', 'SC-D04-2', 'SC-D04-2', '上,下', 'SC-D04-2'],
      ['area-all', 'SC-D05-1', 'SC-D05-1', '上,下', 'SC-D05-1'],
      ['area-all', 'SC-D05-2', 'SC-D05-2', '上,下', 'SC-D05-2'],
      ['area-all', 'SC-D06-1', 'SC-D06-1', '上,下', 'SC-D06-1'],
      ['area-all', 'SC-D06-2', 'SC-D06-2', '上,下', 'SC-D06-2'],
      ['area-all', 'SC-D07-1', 'SC-D07-1', '上,下', 'SC-D07-1'],
      ['area-all', 'SC-D07-2', 'SC-D07-2', '上,下', 'SC-D07-2'],
      ['area-all', 'SC-D08-1', 'SC-D08-1', '上,下', 'SC-D08-1'],
      ['area-all', 'SC-D08-2', 'SC-D08-2', '上,下', 'SC-D08-2'],
      ['area-all', 'SC-D09-1', 'SC-D09-1', '上,下', 'SC-D09-1'],
      ['area-all', 'SC-D09-2', 'SC-D09-2', '上,下', 'SC-D09-2'],
      ['area-all', 'SC-D10-1', 'SC-D10-1', '上,下', 'SC-D10-1'],
      ['area-all', 'SC-D10-2', 'SC-D10-2', '上,下', 'SC-D10-2'],
      ['area-all', 'SC-D11-1', 'SC-D11-1', '上,下', 'SC-D11-1'],
      ['area-all', 'SC-D11-2', 'SC-D11-2', '上,下', 'SC-D11-2'],
      ['area-all', 'SC-D12-1', 'SC-D12-1', '上,下', 'SC-D12-1'],
      ['area-all', 'SC-D12-2', 'SC-D12-2', '上,下', 'SC-D12-2'],
      ['area-all', 'SC-A01-1', 'SC-A01-1', '上,下', 'SC-A01-1'],
      ['area-all', 'SC-A01-2', 'SC-A01-2', '上,下', 'SC-A01-2'],
      ['area-all', 'SC-A02-1', 'SC-A02-1', '上,下', 'SC-A02-1'],
      ['area-all', 'SC-A02-2', 'SC-A02-2', '上,下', 'SC-A02-2'],
      ['area-all', 'SC-A03-1', 'SC-A03-1', '上,下', 'SC-A03-1'],
      ['area-all', 'SC-A03-2', 'SC-A03-2', '上,下', 'SC-A03-2'],
      ['area-all', 'SC-A04-1', 'SC-A04-1', '上,下', 'SC-A04-1'],
      ['area-all', 'SC-A04-2', 'SC-A04-2', '上,下', 'SC-A04-2'],
      ['area-all', 'SC-A05-1', 'SC-A05-1', '上,下', 'SC-A05-1'],
      ['area-all', 'SC-A05-2', 'SC-A05-2', '上,下', 'SC-A05-2'],
      ['area-all', 'SC-A06-1', 'SC-A06-1', '上,下', 'SC-A06-1'],
      ['area-all', 'SC-A06-2', 'SC-A06-2', '上,下', 'SC-A06-2'],
      ['area-all', 'SC-A07-1', 'SC-A07-1', '上,下', 'SC-A07-1'],
      ['area-all', 'SC-A07-2', 'SC-A07-2', '上,下', 'SC-A07-2'],
      ['area-all', 'SC-A08-1', 'SC-A08-1', '上,下', 'SC-A08-1'],
      ['area-all', 'SC-A08-2', 'SC-A08-2', '上,下', 'SC-A08-2'],
      ['area-all', 'SC-A09-1', 'SC-A09-1', '上,下', 'SC-A09-1'],
      ['area-all', 'SC-A09-2', 'SC-A09-2', '上,下', 'SC-A09-2'],
      ['area-all', 'SC-A09S-1', 'SC-A09S-1', '上,下', 'SC-A09S-1'],
      ['area-all', 'SC-A09S-2', 'SC-A09S-2', '上,下', 'SC-A09S-2'],
      ['area-all', 'SC-A10-1', 'SC-A10-1', '上,下', 'SC-A10-1'],
      ['area-all', 'SC-A10-2', 'SC-A10-2', '上,下', 'SC-A10-2'],
      ['area-all', 'SC-A11-1', 'SC-A11-1', '上,下', 'SC-A11-1'],
      ['area-all', 'SC-A11-2', 'SC-A11-2', '上,下', 'SC-A11-2'],
      ['area-all', 'SC-A12-1', 'SC-A12-1', '上,下', 'SC-A12-1'],
      ['area-all', 'SC-A12-2', 'SC-A12-2', '上,下', 'SC-A12-2'],
      ['area-all', 'SC-B02-1', 'SC-B02-1', '上,下', 'SC-B02-1'],
      ['area-all', 'SC-B02-2', 'SC-B02-2', '上,下', 'SC-B02-2'],
      ['area-all', 'SC-B03-1', 'SC-B03-1', '上,下', 'SC-B03-1'],
      ['area-all', 'SC-B03-2', 'SC-B03-2', '上,下', 'SC-B03-2'],
      ['area-all', 'SC-B04-1', 'SC-B04-1', '上,下', 'SC-B04-1'],
      ['area-all', 'SC-B04-2', 'SC-B04-2', '上,下', 'SC-B04-2'],
      ['area-all', 'SC-B05-1', 'SC-B05-1', '上,下', 'SC-B05-1'],
      ['area-all', 'SC-B05-2', 'SC-B05-2', '上,下', 'SC-B05-2'],
      ['area-all', 'SC-B07-1', 'SC-B07-1', '上,下', 'SC-B07-1'],
      ['area-all', 'SC-B07-2', 'SC-B07-2', '上,下', 'SC-B07-2'],
      ['area-all', 'SC-B09-1', 'SC-B09-1', '上,下', 'SC-B09-1'],
      ['area-all', 'SC-B09-2', 'SC-B09-2', '上,下', 'SC-B09-2'],
      ['area-all', 'SC-B09S-1', 'SC-B09S-1', '上,下', 'SC-B09S-1'],
      ['area-all', 'SC-B09S-2', 'SC-B09S-2', '上,下', 'SC-B09S-2'],
      ['area-all', 'SC-B10-1', 'SC-B10-1', '上,下', 'SC-B10-1'],
      ['area-all', 'SC-B10-2', 'SC-B10-2', '上,下', 'SC-B10-2'],
      ['area-all', 'SC-B10S-1', 'SC-B10S-1', '上,下', 'SC-B10S-1'],
      ['area-all', 'SC-B10S-2', 'SC-B10S-2', '上,下', 'SC-B10S-2'],
      ['area-all', 'SC-B11-1', 'SC-B11-1', '上,下', 'SC-B11-1'],
      ['area-all', 'SC-B11-2', 'SC-B11-2', '上,下', 'SC-B11-2'],
      ['area-all', 'SC-B12-1', 'SC-B12-1', '上,下', 'SC-B12-1'],
      ['area-all', 'SC-B12-2', 'SC-B12-2', '上,下', 'SC-B12-2'],
      ['area-all', 'SC-E04-1', 'SC-E04-1', '上,下', 'SC-E04-1'],
      ['area-all', 'SC-E04-2', 'SC-E04-2', '上,下', 'SC-E04-2'],
      ['area-all', 'SC-E06-1', 'SC-E06-1', '上,下', 'SC-E06-1'],
      ['area-all', 'SC-E06-2', 'SC-E06-2', '上,下', 'SC-E06-2'],
      ['area-all', 'SC-E08-1', 'SC-E08-1', '上,下', 'SC-E08-1'],
      ['area-all', 'SC-E08-2', 'SC-E08-2', '上,下', 'SC-E08-2'],
      ['area-all', 'SC-E09-1', 'SC-E09-1', '上,下', 'SC-E09-1'],
      ['area-all', 'SC-E09-2', 'SC-E09-2', '上,下', 'SC-E09-2'],
      ['area-all', 'SC-F-1', 'SC-F-1', '上,下', 'SC-F-1'],
      ['area-all', 'SC-F-2', 'SC-F-2', '上,下', 'SC-F-2'],
      ['area-all', 'SC-G-1', 'SC-G-1', '上,下', 'SC-G-1'],
      ['area-all', 'SC-G-2', 'SC-G-2', '上,下', 'SC-G-2'],
      ['area-all', 'SC-H01-1', 'SC-H01-1', '上,下', 'SC-H01-1'],
      ['area-all', 'SC-H01-2', 'SC-H01-2', '上,下', 'SC-H01-2'],
      ['area-all', 'SC-H02-1', 'SC-H02-1', '上,下', 'SC-H02-1'],
      ['area-all', 'SC-H02-2', 'SC-H02-2', '上,下', 'SC-H02-2'],
      ['area-all', 'SC-H03-1', 'SC-H03-1', '上,下', 'SC-H03-1'],
      ['area-all', 'SC-H03-2', 'SC-H03-2', '上,下', 'SC-H03-2'],
      ['area-all', 'SC-H04-1', 'SC-H04-1', '上,下', 'SC-H04-1'],
      ['area-all', 'SC-H04-2', 'SC-H04-2', '上,下', 'SC-H04-2'],
      ['area-all', 'SC-H06-1', 'SC-H06-1', '上,下', 'SC-H06-1'],
      ['area-all', 'SC-H06-2', 'SC-H06-2', '上,下', 'SC-H06-2'],
      ['area-all', 'SC-H07-1', 'SC-H07-1', '上,下', 'SC-H07-1'],
      ['area-all', 'SC-H07-2', 'SC-H07-2', '上,下', 'SC-H07-2'],
      ['area-all', 'SC-J01-1', 'SC-J01-1', '上,下', 'SC-J01-1'],
      ['area-all', 'SC-J01-2', 'SC-J01-2', '上,下', 'SC-J01-2'],
      ['area-all', 'SC-J02-1', 'SC-J02-1', '上,下', 'SC-J02-1'],
      ['area-all', 'SC-J02-2', 'SC-J02-2', '上,下', 'SC-J02-2'],
      ['area-all', 'SC-J03-1', 'SC-J03-1', '上,下', 'SC-J03-1'],
      ['area-all', 'SC-J03-2', 'SC-J03-2', '上,下', 'SC-J03-2'],
      ['area-all', 'SC-J04-1', 'SC-J04-1', '上,下', 'SC-J04-1'],
      ['area-all', 'SC-J04-2', 'SC-J04-2', '上,下', 'SC-J04-2'],
      ['area-all', 'SC-J05-1', 'SC-J05-1', '上,下', 'SC-J05-1'],
      ['area-all', 'SC-J05-2', 'SC-J05-2', '上,下', 'SC-J05-2'],
      ['area-all', 'SC-J06-1', 'SC-J06-1', '上,下', 'SC-J06-1'],
      ['area-all', 'SC-J06-2', 'SC-J06-2', '上,下', 'SC-J06-2'],
      ['area-all', 'SC-J07-1', 'SC-J07-1', '上,下', 'SC-J07-1'],
      ['area-all', 'SC-J07-2', 'SC-J07-2', '上,下', 'SC-J07-2'],
      ['area-all', 'SC-J08-1', 'SC-J08-1', '上,下', 'SC-J08-1'],
      ['area-all', 'SC-J08-2', 'SC-J08-2', '上,下', 'SC-J08-2'],
      ['area-all', 'SC-K01-1', 'SC-K01-1', '上,下', 'SC-K01-1'],
      ['area-all', 'SC-K01-2', 'SC-K01-2', '上,下', 'SC-K01-2'],
      ['area-all', 'SC-K02-1', 'SC-K02-1', '上,下', 'SC-K02-1'],
      ['area-all', 'SC-K02-2', 'SC-K02-2', '上,下', 'SC-K02-2'],
      ['area-all', 'SC-K03-1', 'SC-K03-1', '上,下', 'SC-K03-1'],
      ['area-all', 'SC-K03-2', 'SC-K03-2', '上,下', 'SC-K03-2'],
      ['area-all', 'SC-K04-1', 'SC-K04-1', '上,下', 'SC-K04-1'],
      ['area-all', 'SC-K04-2', 'SC-K04-2', '上,下', 'SC-K04-2'],
      ['area-all', 'SC-K05-1', 'SC-K05-1', '上,下', 'SC-K05-1'],
      ['area-all', 'SC-K05-2', 'SC-K05-2', '上,下', 'SC-K05-2'],
      ['area-all', 'SC-K06-1', 'SC-K06-1', '上,下', 'SC-K06-1'],
      ['area-all', 'SC-K06-2', 'SC-K06-2', '上,下', 'SC-K06-2'],
      ['area-all', 'SC-L01-1', 'SC-L01-1', '上,下', 'SC-L01-1'],
      ['area-all', 'SC-L01-2', 'SC-L01-2', '上,下', 'SC-L01-2'],
      ['area-all', 'SC-L02-1', 'SC-L02-1', '上,下', 'SC-L02-1'],
      ['area-all', 'SC-L02-2', 'SC-L02-2', '上,下', 'SC-L02-2'],
      ['area-all', 'SC-L03-1', 'SC-L03-1', '上,下', 'SC-L03-1'],
      ['area-all', 'SC-L03-2', 'SC-L03-2', '上,下', 'SC-L03-2'],
      ['area-all', 'SC-L04-1', 'SC-L04-1', '上,下', 'SC-L04-1'],
      ['area-all', 'SC-L04-2', 'SC-L04-2', '上,下', 'SC-L04-2'],
      ['area-all', 'SC-L05-1', 'SC-L05-1', '上,下', 'SC-L05-1'],
      ['area-all', 'SC-L05-2', 'SC-L05-2', '上,下', 'SC-L05-2'],
      ['area-all', 'SC-L06-1', 'SC-L06-1', '上,下', 'SC-L06-1'],
      ['area-all', 'SC-L06-2', 'SC-L06-2', '上,下', 'SC-L06-2'],
      ['area-all', 'SC-L07-1', 'SC-L07-1', '上,下', 'SC-L07-1'],
      ['area-all', 'SC-L07-2', 'SC-L07-2', '上,下', 'SC-L07-2'],
      ['area-all', 'SC-M03-1', 'SC-M03-1', '上,下', 'SC-M03-1'],
      ['area-all', 'SC-M03-2', 'SC-M03-2', '上,下', 'SC-M03-2'],
      ['area-all', 'SC-M04-1', 'SC-M04-1', '上,下', 'SC-M04-1'],
      ['area-all', 'SC-M04-2', 'SC-M04-2', '上,下', 'SC-M04-2'],
      ['area-all', 'SC-M05-1', 'SC-M05-1', '上,下', 'SC-M05-1'],
      ['area-all', 'SC-M05-2', 'SC-M05-2', '上,下', 'SC-M05-2'],
      ['area-all', 'SC-M06-1', 'SC-M06-1', '上,下', 'SC-M06-1'],
      ['area-all', 'SC-M06-2', 'SC-M06-2', '上,下', 'SC-M06-2'],
      ['area-all', 'SC-M07-1', 'SC-M07-1', '上,下', 'SC-M07-1'],
      ['area-all', 'SC-M07-2', 'SC-M07-2', '上,下', 'SC-M07-2'],
      ['area-all', 'SC-M08-1', 'SC-M08-1', '上,下', 'SC-M08-1'],
      ['area-all', 'SC-M08-2', 'SC-M08-2', '上,下', 'SC-M08-2'],
      ['area-all', 'SC-Q01-1', 'SC-Q01-1', '上,下', 'SC-Q01-1'],
      ['area-all', 'SC-Q01-2', 'SC-Q01-2', '上,下', 'SC-Q01-2'],
      ['area-all', 'SC-Q02-1', 'SC-Q02-1', '上,下', 'SC-Q02-1'],
      ['area-all', 'SC-Q02-2', 'SC-Q02-2', '上,下', 'SC-Q02-2'],
      ['area-all', 'SC-T01-1', 'SC-T01-1', '上,下', 'SC-T01-1'],
      ['area-all', 'SC-T01-2', 'SC-T01-2', '上,下', 'SC-T01-2'],
      ['area-all', 'SC-T02-1', 'SC-T02-1', '上,下', 'SC-T02-1'],
      ['area-all', 'SC-T02-2', 'SC-T02-2', '上,下', 'SC-T02-2'],
      ['area-all', 'SC-T03-1', 'SC-T03-1', '上,下', 'SC-T03-1'],
      ['area-all', 'SC-T03-2', 'SC-T03-2', '上,下', 'SC-T03-2'],
      ['area-all', 'SC-T04-1', 'SC-T04-1', '上,下', 'SC-T04-1'],
      ['area-all', 'SC-T04-2', 'SC-T04-2', '上,下', 'SC-T04-2'],
      ['area-all', 'SC-AP01', 'SC-AP01', '上,下', 'SC-AP01'],
      ['area-all', 'SC-AP02', 'SC-AP02', '上,下', 'SC-AP02'],
      ['area-all', 'SC-AP03', 'SC-AP03', '上,下', 'SC-AP03'],
      ['area-all', 'SC-AP05', 'SC-AP05', '上,下', 'SC-AP05'],
      ['area-all', 'SC-AP06', 'SC-AP06', '上,下', 'SC-AP06'],
      ['area-all', 'SC-AP07', 'SC-AP07', '上,下', 'SC-AP07'],
      ['area-all', 'SC-AP08', 'SC-AP08', '上,下', 'SC-AP08'],
      ['area-all', 'SC-AP09', 'SC-AP09', '上,下', 'SC-AP09'],
      ['area-all', 'SC-AP10', 'SC-AP10', '上,下', 'SC-AP10'],
      ['area-all', 'SC-AP11', 'SC-AP11', '上,下', 'SC-AP11'],
      ['area-all', 'SC-AP12', 'SC-AP12', '上,下', 'SC-AP12'],
      ['area-all', 'SC-AP13', 'SC-AP13', '上,下', 'SC-AP13'],
      ['area-all', 'SC-AP14', 'SC-AP14', '上,下', 'SC-AP14'],
      ['area-all', 'SC-AP15', 'SC-AP15', '上,下', 'SC-AP15'],
      ['area-all', 'SC-AP16', 'SC-AP16', '上,下', 'SC-AP16'],
      ['area-all', 'SC-AP17', 'SC-AP17', '上,下', 'SC-AP17'],
      ['area-all', 'SC-AP18', 'SC-AP18', '上,下', 'SC-AP18'],
      ['area-all', 'SC-AP19', 'SC-AP19', '上,下', 'SC-AP19'],
      ['area-all', 'SC-AP20', 'SC-AP20', '上,下', 'SC-AP20'],
      ['area-all', 'SC-AP21', 'SC-AP21', '上,下', 'SC-AP21'],
      ['area-all', 'SC-AP22', 'SC-AP22', '上,下', 'SC-AP22'],
      ['area-all', 'SC-AP23', 'SC-AP23', '上,下', 'SC-AP23'],
      ['area-all', 'SC-AP24', 'SC-AP24', '上,下', 'SC-AP24'],
      ['area-all', 'SC-AP25', 'SC-AP25', '上,下', 'SC-AP25'],
      ['area-all', 'SC-AP26', 'SC-AP26', '上,下', 'SC-AP26'],
      ['area-all', 'SC-AP27', 'SC-AP27', '上,下', 'SC-AP27'],
      ['area-all', 'SC-AP44', 'SC-AP44', '上,下', 'SC-AP44'],
      ['area-all', 'SC-AP45', 'SC-AP45', '上,下', 'SC-AP45'],
      ['area-all', 'SC-AP46', 'SC-AP46', '上,下', 'SC-AP46'],
      ['area-all', 'SC-AP47', 'SC-AP47', '上,下', 'SC-AP47'],
      ['area-all', 'SC-AP48', 'SC-AP48', '上,下', 'SC-AP48'],
      ['area-all', 'SC-AP49', 'SC-AP49', '上,下', 'SC-AP49'],
      ['area-all', 'SC-AP50', 'SC-AP50', '上,下', 'SC-AP50'],
      ['area-all', 'SC-AP51', 'SC-AP51', '上,下', 'SC-AP51'],
      ['area-all', 'SC-AP52', 'SC-AP52', '上,下', 'SC-AP52'],
      ['area-all', 'SC-AP53', 'SC-AP53', '上,下', 'SC-AP53'],
      ['area-all', 'SC-AP54', 'SC-AP54', '上,下', 'SC-AP54'],
      ['area-all', 'SC-AP55', 'SC-AP55', '上,下', 'SC-AP55'],
      ['area-all', 'SC-AP56', 'SC-AP56', '上,下', 'SC-AP56'],
      ['area-all', 'SC-AP57', 'SC-AP57', '上,下', 'SC-AP57'],
      ['area-all', 'SC-AP58', 'SC-AP58', '上,下', 'SC-AP58'],
      ['area-all', 'SC-AP59', 'SC-AP59', '上,下', 'SC-AP59'],
      ['area-all', 'SC-AP60', 'SC-AP60', '上,下', 'SC-AP60'],
      ['area-all', 'SC-AP61', 'SC-AP61', '上,下', 'SC-AP61'],
      ['area-all', 'SC-AP62', 'SC-AP62', '上,下', 'SC-AP62'],
      ['area-all', 'SC-AP63', 'SC-AP63', '上,下', 'SC-AP63'],
      ['area-all', 'SC-AP64', 'SC-AP64', '上,下', 'SC-AP64'],
      ['area-all', 'SC-AP65', 'SC-AP65', '上,下', 'SC-AP65'],
      ['area-all', 'SC-AP66', 'SC-AP66', '上,下', 'SC-AP66'],
      ['area-all', 'SC-AP67', 'SC-AP67', '上,下', 'SC-AP67'],
      ['area-all', 'SC-AP68', 'SC-AP68', '上,下', 'SC-AP68'],
      ['area-all', 'SC-AP69', 'SC-AP69', '上,下', 'SC-AP69'],
      ['area-all', 'SC-AP70', 'SC-AP70', '上,下', 'SC-AP70'],
      ['area-all', 'SC-AP71', 'SC-AP71', '上,下', 'SC-AP71'],
      ['area-all', 'SC-AP80', 'SC-AP80', '上,下', 'SC-AP80'],
      ['area-all', 'SC-AP81', 'SC-AP81', '上,下', 'SC-AP81'],
      ['area-all', 'SC-AP82', 'SC-AP82', '上,下', 'SC-AP82'],
      ['area-all', 'SC-AP83', 'SC-AP83', '上,下', 'SC-AP83'],
      ['area-all', 'SC-AP84', 'SC-AP84', '上,下', 'SC-AP84'],
      ['area-all', 'SC-AP85', 'SC-AP85', '上,下', 'SC-AP85'],
      ['area-all', 'SC-AP86', 'SC-AP86', '上,下', 'SC-AP86'],
      ['area-all', 'SC-AP87', 'SC-AP87', '上,下', 'SC-AP87'],
      ['area-all', 'SC-AP90', 'SC-AP90', '上,下', 'SC-AP90'],
      ['area-all', 'SC-AP91', 'SC-AP91', '上,下', 'SC-AP91'],
      ['area-all', 'SC-AP-M', 'SC-AP-M', '上,下', 'SC-AP-M'],
      ['area-all', 'SC-GSE01', 'SC-GSE01', '上,下', 'SC-GSE01'],
      ['area-all', 'SC-GSE02', 'SC-GSE02', '上,下', 'SC-GSE02'],
      ['area-all', 'SC-GSE03', 'SC-GSE03', '上,下', 'SC-GSE03'],
      ['area-all', 'SC-GSE04', 'SC-GSE04', '上,下', 'SC-GSE04'],
      ['area-all', 'SC-GSE05', 'SC-GSE05', '上,下', 'SC-GSE05'],
      ['area-all', 'SC-GSE06', 'SC-GSE06', '上,下', 'SC-GSE06'],
      ['area-all', 'SC-GSE07', 'SC-GSE07', '上,下', 'SC-GSE07'],
      ['area-all', 'SC-HA01', 'SC-HA01', '上,下', 'SC-HA01'],
      ['area-all', 'SC-HA02', 'SC-HA02', '上,下', 'SC-HA02'],
      ['area-all', 'SC-HA03', 'SC-HA03', '上,下', 'SC-HA03'],
      ['area-all', 'SC-HA04', 'SC-HA04', '上,下', 'SC-HA04'],
      ['area-all', 'SC-HA05', 'SC-HA05', '上,下', 'SC-HA05'],
      ['area-all', 'SC-HA06', 'SC-HA06', '上,下', 'SC-HA06'],
      ['area-all', 'SC-HA07', 'SC-HA07', '上,下', 'SC-HA07'],
      ['area-all', 'SC-HA08', 'SC-HA08', '上,下', 'SC-HA08'],
      ['area-all', 'SC-HA09', 'SC-HA09', '上,下', 'SC-HA09'],
      ['area-all', 'SC-HA10', 'SC-HA10', '上,下', 'SC-HA10'],
      ['area-all', 'SC-HA11', 'SC-HA11', '上,下', 'SC-HA11'],
      ['area-all', 'SC-HA12', 'SC-HA12', '上,下', 'SC-HA12'],
      ['area-all', 'SC-HA13', 'SC-HA13', '上,下', 'SC-HA13'],
      ['area-all', 'SC-HA14', 'SC-HA14', '上,下', 'SC-HA14'],
      ['area-all', 'SC-HA15', 'SC-HA15', '上,下', 'SC-HA15'],
      ['area-all', 'SC-HA16', 'SC-HA16', '上,下', 'SC-HA16'],
      ['area-all', 'SC-HA17', 'SC-HA17', '上,下', 'SC-HA17'],
      ['area-all', 'SC-HA18', 'SC-HA18', '上,下', 'SC-HA18'],
      ['area-all', 'SC-HA19', 'SC-HA19', '上,下', 'SC-HA19'],
      ['area-all', 'SC-HA20', 'SC-HA20', '上,下', 'SC-HA20'],
      ['area-all', 'SC-HA21', 'SC-HA21', '上,下', 'SC-HA21'],
      ['area-all', 'SC-HA22', 'SC-HA22', '上,下', 'SC-HA22'],
      ['area-all', 'SC-HA23', 'SC-HA23', '上,下', 'SC-HA23'],
      ['area-all', 'SC-HA24', 'SC-HA24', '上,下', 'SC-HA24'],
      ['area-all', 'SC-HA25', 'SC-HA25', '上,下', 'SC-HA25'],
      ['area-all', 'SC-HA26', 'SC-HA26', '上,下', 'SC-HA26'],
      ['area-all', 'SC-HA27', 'SC-HA27', '上,下', 'SC-HA27'],
      ['area-all', 'SC-HA28', 'SC-HA28', '上,下', 'SC-HA28'],
      ['area-all', 'SC-HA29', 'SC-HA29', '上,下', 'SC-HA29'],
      ['area-all', 'SC-HA30', 'SC-HA30', '上,下', 'SC-HA30'],
      ['area-all', 'SC-HA31', 'SC-HA31', '上,下', 'SC-HA31'],
      ['area-all', 'SC-HA32', 'SC-HA32', '上,下', 'SC-HA32'],
      ['area-all', 'SC-HA33', 'SC-HA33', '上,下', 'SC-HA33'],
      ['area-all', 'SC-HA34', 'SC-HA34', '上,下', 'SC-HA34'],
      ['area-all', 'SC-HA35', 'SC-HA35', '上,下', 'SC-HA35'],
      ['area-all', 'SC-HA36', 'SC-HA36', '上,下', 'SC-HA36'],
      ['area-all', 'SC-HA37', 'SC-HA37', '上,下', 'SC-HA37'],
      ['area-all', 'SC-HA38', 'SC-HA38', '上,下', 'SC-HA38'],
      ['area-all', 'SC-HA39', 'SC-HA39', '上,下', 'SC-HA39'],
      ['area-all', 'SC-HA40', 'SC-HA40', '上,下', 'SC-HA40'],
      ['area-all', 'SC-HA41', 'SC-HA41', '上,下', 'SC-HA41'],
      ['area-all', 'SC-HA42', 'SC-HA42', '上,下', 'SC-HA42'],
      ['area-all', 'SC-HA43', 'SC-HA43', '上,下', 'SC-HA43'],
      ['area-all', 'SC-HA44', 'SC-HA44', '上,下', 'SC-HA44'],
      ['area-all', 'SC-HA45', 'SC-HA45', '上,下', 'SC-HA45'],
      ['area-all', 'SC-HA46', 'SC-HA46', '上,下', 'SC-HA46'],
      ['area-all', 'SC-HA47', 'SC-HA47', '上,下', 'SC-HA47'],
      ['area-all', 'SC-HA48', 'SC-HA48', '上,下', 'SC-HA48'],
      ['area-all', 'SC-HA49', 'SC-HA49', '上,下', 'SC-HA49'],
      ['area-all', 'SC-HA50', 'SC-HA50', '上,下', 'SC-HA50'],
      ['area-all', 'SC-HA51', 'SC-HA51', '上,下', 'SC-HA51'],
      ['area-all', 'SC-HA52', 'SC-HA52', '上,下', 'SC-HA52'],
      ['area-all', 'SC-HA53', 'SC-HA53', '上,下', 'SC-HA53'],
      ['area-all', 'SC-HA54', 'SC-HA54', '上,下', 'SC-HA54'],
      ['area-all', 'SC-HA55', 'SC-HA55', '上,下', 'SC-HA55'],
      ['area-all', 'SC-HA56', 'SC-HA56', '上,下', 'SC-HA56'],
      ['area-all', 'SC-HA57', 'SC-HA57', '上,下', 'SC-HA57'],
      ['area-all', 'SC-HA58', 'SC-HA58', '上,下', 'SC-HA58'],
      ['area-all', 'SC-HA59', 'SC-HA59', '上,下', 'SC-HA59'],
      ['area-all', 'SC-HA60', 'SC-HA60', '上,下', 'SC-HA60'],
      ['area-all', 'SC-HA61', 'SC-HA61', '上,下', 'SC-HA61'],
      ['area-all', 'SC-HA62', 'SC-HA62', '上,下', 'SC-HA62'],
      ['area-all', 'SC-HA63', 'SC-HA63', '上,下', 'SC-HA63'],
      ['area-all', 'SC-HA64', 'SC-HA64', '上,下', 'SC-HA64'],
      ['area-all', 'SC-HA65', 'SC-HA65', '上,下', 'SC-HA65'],
      ['area-all', 'SC-KN01', 'SC-KN01', '上,下', 'SC-KN01'],
      ['area-all', 'SC-KN02', 'SC-KN02', '上,下', 'SC-KN02'],
      ['area-all', 'SC-KN03', 'SC-KN03', '上,下', 'SC-KN03'],
      ['area-all', 'SC-KN04', 'SC-KN04', '上,下', 'SC-KN04'],
      ['area-all', 'SC-KN05', 'SC-KN05', '上,下', 'SC-KN05'],
      ['area-all', 'SC-KN06', 'SC-KN06', '上,下', 'SC-KN06'],
      ['area-all', 'SC-KN07', 'SC-KN07', '上,下', 'SC-KN07'],
      ['area-all', 'SC-KN08', 'SC-KN08', '上,下', 'SC-KN08'],
      ['area-all', 'SC-KN09', 'SC-KN09', '上,下', 'SC-KN09'],
      ['area-all', 'SC-KN10', 'SC-KN10', '上,下', 'SC-KN10'],
      ['area-all', 'SC-KN11', 'SC-KN11', '上,下', 'SC-KN11'],
      ['area-all', 'SC-KN12', 'SC-KN12', '上,下', 'SC-KN12'],
      ['area-all', 'SC-KN13', 'SC-KN13', '上,下', 'SC-KN13'],
      ['area-all', 'SC-KN14', 'SC-KN14', '上,下', 'SC-KN14'],
      ['area-all', 'SC-KN15', 'SC-KN15', '上,下', 'SC-KN15'],
      ['area-all', 'SC-KN16', 'SC-KN16', '上,下', 'SC-KN16'],
      ['area-all', 'SC-KN17', 'SC-KN17', '上,下', 'SC-KN17'],
      ['area-all', 'SC-KN18', 'SC-KN18', '上,下', 'SC-KN18'],
      ['area-all', 'SC-KN19', 'SC-KN19', '上,下', 'SC-KN19'],
      ['area-all', 'SC-KN20', 'SC-KN20', '上,下', 'SC-KN20'],
      ['area-all', 'SC-KN21', 'SC-KN21', '上,下', 'SC-KN21'],
      ['area-all', 'SC-KN22', 'SC-KN22', '上,下', 'SC-KN22'],
      ['area-all', 'SC-KN23', 'SC-KN23', '上,下', 'SC-KN23'],
      ['area-all', 'SC-KN24', 'SC-KN24', '上,下', 'SC-KN24'],
      ['area-all', 'SC-N01', 'SC-N01', '上,下', 'SC-N01'],
      ['area-all', 'SC-N02', 'SC-N02', '上,下', 'SC-N02'],
      ['area-all', 'SC-N03', 'SC-N03', '上,下', 'SC-N03'],
      ['area-all', 'AS-RWY', 'AS-RWY', '上,下', 'AS-RWY'],
      ['area-all', 'AS-P01', 'AS-P01', '上,下', 'AS-P01'],
      ['area-all', 'AS-P02', 'AS-P02', '上,下', 'AS-P02'],
      ['area-all', 'AS-P03', 'AS-P03', '上,下', 'AS-P03'],
      ['area-all', 'AS-P04', 'AS-P04', '上,下', 'AS-P04'],
      ['area-all', 'AS-P05', 'AS-P05', '上,下', 'AS-P05'],
      ['area-all', 'AS-T01', 'AS-T01', '上,下', 'AS-T01'],
      ['area-all', 'AS-T02', 'AS-T02', '上,下', 'AS-T02'],
      ['area-all', 'AS-T03', 'AS-T03', '上,下', 'AS-T03'],
      ['area-all', 'AS-T04', 'AS-T04', '上,下', 'AS-T04'],
      ['area-all', 'AS-T05', 'AS-T05', '上,下', 'AS-T05'],
      ['area-all', 'AS-A01', 'AS-A01', '上,下', 'AS-A01'],
      ['area-all', 'AS-A02', 'AS-A02', '上,下', 'AS-A02'],
      ['area-all', 'AS-AP01', 'AS-AP01', '上,下', 'AS-AP01'],
      ['area-all', 'AS-AP02', 'AS-AP02', '上,下', 'AS-AP02'],
      ['area-all', 'AS-AP03', 'AS-AP03', '上,下', 'AS-AP03'],
      ['area-all', 'AS-AP04', 'AS-AP04', '上,下', 'AS-AP04'],
      ['area-all', 'AS-AP05', 'AS-AP05', '上,下', 'AS-AP05'],
      ['area-all', 'AS-AP06', 'AS-AP06', '上,下', 'AS-AP06'],
      ['area-all', 'AS-HA01', 'AS-HA01', '上,下', 'AS-HA01'],
      ['area-all', 'AS-HA02', 'AS-HA02', '上,下', 'AS-HA02'],
      ['area-all', 'AS-HA03', 'AS-HA03', '上,下', 'AS-HA03'],
      ['area-all', 'AS-HA04', 'AS-HA04', '上,下', 'AS-HA04'],
      ['area-all', 'AS-HA05', 'AS-HA05', '上,下', 'AS-HA05'],
      ['area-all', 'AS-HA06', 'AS-HA06', '上,下', 'AS-HA06'],
      ['area-all', 'AS-HA07', 'AS-HA07', '上,下', 'AS-HA07'],
      ['area-all', 'AS-HA08', 'AS-HA08', '上,下', 'AS-HA08'],
      ['area-all', 'AS-HA09', 'AS-HA09', '上,下', 'AS-HA09'],
      ['area-all', 'AS-HA10', 'AS-HA10', '上,下', 'AS-HA10'],
      ['area-all', 'AS-HA11', 'AS-HA11', '上,下', 'AS-HA11'],
      ['area-all', 'AS-HA12', 'AS-HA12', '上,下', 'AS-HA12'],
      ['area-all', 'AS-HA13', 'AS-HA13', '上,下', 'AS-HA13'],
      ['area-all', 'AS-HA14', 'AS-HA14', '上,下', 'AS-HA14'],
      ['area-all', 'AS-HA15', 'AS-HA15', '上,下', 'AS-HA15'],
      ['area-all', 'AS-HA16', 'AS-HA16', '上,下', 'AS-HA16'],
      ['area-all', 'AS-HA17', 'AS-HA17', '上,下', 'AS-HA17'],
      ['area-all', 'AS-HA18', 'AS-HA18', '上,下', 'AS-HA18'],
      ['area-all', 'AS-HA19', 'AS-HA19', '上,下', 'AS-HA19'],
      ['area-all', 'AS-HA20', 'AS-HA20', '上,下', 'AS-HA20'],
      ['area-all', 'AS-HA21', 'AS-HA21', '上,下', 'AS-HA21'],
      ['area-all', 'AS-HA22', 'AS-HA22', '上,下', 'AS-HA22'],
      ['area-all', 'AS-HA23', 'AS-HA23', '上,下', 'AS-HA23'],
      ['area-all', 'AS-N01', 'AS-N01', '上,下', 'AS-N01'],
      ['area-all', 'AS-N02', 'AS-N02', '上,下', 'AS-N02'],
      ['area-all', 'AS-N03', 'AS-N03', '上,下', 'AS-N03'],
      ['area-all', 'AS-N04', 'AS-N04', '上,下', 'AS-N04'],
      ['area-all', 'AS-N05', 'AS-N05', '上,下', 'AS-N05'],
      ['area-all', 'AS-N06', 'AS-N06', '上,下', 'AS-N06'],
      ['area-all', 'AS-N07', 'AS-N07', '上,下', 'AS-N07'],
      ['area-all', 'AS-N08', 'AS-N08', '上,下', 'AS-N08'],
      ['area-all', 'AS-N09', 'AS-N09', '上,下', 'AS-N09'],
      ['area-all', 'AS-N10', 'AS-N10', '上,下', 'AS-N10'],
      ['area-all', 'AS-N11', 'AS-N11', '上,下', 'AS-N11'],
      ['area-all', 'AS-N12', 'AS-N12', '上,下', 'AS-N12'],
      ['area-all', 'AS-N13', 'AS-N13', '上,下', 'AS-N13'],
      ['area-all', 'AS-N14', 'AS-N14', '上,下', 'AS-N14'],
      ['area-all', 'AS-N15', 'AS-N15', '上,下', 'AS-N15'],
      ['area-all', 'AS-N16', 'AS-N16', '上,下', 'AS-N16'],
      ['area-all', 'AS-N17', 'AS-N17', '上,下', 'AS-N17'],
      ['area-all', 'AS-N18', 'AS-N18', '上,下', 'AS-N18'],
      ['area-all', 'AS-N19', 'AS-N19', '上,下', 'AS-N19'],
      ['area-all', 'AS-S01', 'AS-S01', '上,下', 'AS-S01'],
      ['area-all', 'AS-S02', 'AS-S02', '上,下', 'AS-S02'],
      ['area-all', 'MM-RWY', 'MM-RWY', '上,下', 'MM-RWY'],
      ['area-all', 'MM-P01', 'MM-P01', '上,下', 'MM-P01'],
      ['area-all', 'MM-P02', 'MM-P02', '上,下', 'MM-P02'],
      ['area-all', 'MM-P03', 'MM-P03', '上,下', 'MM-P03'],
      ['area-all', 'MM-P04', 'MM-P04', '上,下', 'MM-P04'],
      ['area-all', 'MM-P05', 'MM-P05', '上,下', 'MM-P05'],
      ['area-all', 'MM-P06', 'MM-P06', '上,下', 'MM-P06'],
      ['area-all', 'MM-T01', 'MM-T01', '上,下', 'MM-T01'],
      ['area-all', 'MM-T02', 'MM-T02', '上,下', 'MM-T02'],
      ['area-all', 'MM-T03', 'MM-T03', '上,下', 'MM-T03'],
      ['area-all', 'MM-T04', 'MM-T04', '上,下', 'MM-T04'],
      ['area-all', 'MM-T05', 'MM-T05', '上,下', 'MM-T05'],
      ['area-all', 'MM-T06', 'MM-T06', '上,下', 'MM-T06'],
      ['area-all', 'MM-TB', 'MM-TB', '上,下', 'MM-TB'],
      ['area-all', 'MM-AP01', 'MM-AP01', '上,下', 'MM-AP01'],
      ['area-all', 'MM-AP02', 'MM-AP02', '上,下', 'MM-AP02'],
      ['area-all', 'MM-AP03', 'MM-AP03', '上,下', 'MM-AP03'],
      ['area-all', 'MM-AP04', 'MM-AP04', '上,下', 'MM-AP04'],
      ['area-all', 'MM-AP05', 'MM-AP05', '上,下', 'MM-AP05'],
      ['area-all', 'MM-AP06', 'MM-AP06', '上,下', 'MM-AP06'],
      ['area-all', 'MM-B-AP', 'MM-B-AP', '上,下', 'MM-B-AP'],
      ['area-all', 'MM-N01', 'MM-N01', '上,下', 'MM-N01'],
      ['area-all', 'MM-N02', 'MM-N02', '上,下', 'MM-N02'],
      ['area-all', 'MM-N03', 'MM-N03', '上,下', 'MM-N03'],
      ['area-all', 'MM-N04', 'MM-N04', '上,下', 'MM-N04'],
      ['area-all', 'MM-N05', 'MM-N05', '上,下', 'MM-N05'],
      ['area-all', 'MM-N06', 'MM-N06', '上,下', 'MM-N06'],
      ['area-all', 'MM-N07', 'MM-N07', '上,下', 'MM-N07'],
      ['area-all', 'MM-N08', 'MM-N08', '上,下', 'MM-N08'],
      ['area-all', 'MM-N09', 'MM-N09', '上,下', 'MM-N09'],
      ['area-all', 'MM-N10', 'MM-N10', '上,下', 'MM-N10'],
      ['area-all', 'MM-N11', 'MM-N11', '上,下', 'MM-N11'],
      ['area-all', 'MM-N12', 'MM-N12', '上,下', 'MM-N12'],
      ['area-all', 'MM-N13', 'MM-N13', '上,下', 'MM-N13'],
      ['area-all', 'MM-N14', 'MM-N14', '上,下', 'MM-N14'],
      ['area-all', 'MM-N15', 'MM-N15', '上,下', 'MM-N15'],
      ['area-all', 'MM-N16', 'MM-N16', '上,下', 'MM-N16'],
      ['area-all', 'MM-N17', 'MM-N17', '上,下', 'MM-N17'],
      ['area-all', 'MM-N18', 'MM-N18', '上,下', 'MM-N18'],
      ['area-all', 'MM-N19', 'MM-N19', '上,下', 'MM-N19'],
      ['area-all', 'MM-N20', 'MM-N20', '上,下', 'MM-N20'],
      ['area-all', 'MM-N21', 'MM-N21', '上,下', 'MM-N21'],
      ['area-all', 'MM-N22', 'MM-N22', '上,下', 'MM-N22'],
      ['area-all', 'MM-N23', 'MM-N23', '上,下', 'MM-N23'],
      ['area-all', 'MM-K01', 'MM-K01', '上,下', 'MM-K01'],
      ['area-all', 'MM-K02', 'MM-K02', '上,下', 'MM-K02'],
      ['area-all', 'MM-K03', 'MM-K03', '上,下', 'MM-K03'],
      ['area-all', 'MM-K04', 'MM-K04', '上,下', 'MM-K04'],
      ['area-all', 'MM-K05', 'MM-K05', '上,下', 'MM-K05'],
      ['area-all', 'MM-K06', 'MM-K06', '上,下', 'MM-K06'],
      ['area-all', 'MM-S01', 'MM-S01', '上,下', 'MM-S01'],
      ['area-all', 'MM-S02', 'MM-S02', '上,下', 'MM-S02'],
      ['area-all', 'MM-S03', 'MM-S03', '上,下', 'MM-S03'],
      ['area-all', 'WK-RWY', 'WK-RWY', '上,下', 'WK-RWY'],
      ['area-all', 'WK-T01', 'WK-T01', '上,下', 'WK-T01'],
      ['area-all', 'WK-AP01', 'WK-AP01', '上,下', 'WK-AP01'],
      ['area-all', 'WK-AP02', 'WK-AP02', '上,下', 'WK-AP02'],
      ['area-all', 'WK-AP03', 'WK-AP03', '上,下', 'WK-AP03'],
      ['area-all', 'WK-AP04', 'WK-AP04', '上,下', 'WK-AP04'],
      ['area-all', 'WK-AP05', 'WK-AP05', '上,下', 'WK-AP05'],
      ['area-all', 'WK-HA01', 'WK-HA01', '上,下', 'WK-HA01'],
      ['area-all', 'WK-HA02', 'WK-HA02', '上,下', 'WK-HA02'],
      ['area-all', 'WK-HA03', 'WK-HA03', '上,下', 'WK-HA03'],
      ['area-all', 'WK-HA04', 'WK-HA04', '上,下', 'WK-HA04'],
      ['area-all', 'WK-HA05', 'WK-HA05', '上,下', 'WK-HA05'],
      ['area-all', 'WK-HA06', 'WK-HA06', '上,下', 'WK-HA06'],
      ['area-all', 'WK-HA07', 'WK-HA07', '上,下', 'WK-HA07'],
      ['area-all', 'WK-HA08', 'WK-HA08', '上,下', 'WK-HA08'],
      ['area-all', 'WK-HA09', 'WK-HA09', '上,下', 'WK-HA09'],
      ['area-all', 'WK-HA10', 'WK-HA10', '上,下', 'WK-HA10'],
      ['area-all', 'WK-HA11', 'WK-HA11', '上,下', 'WK-HA11'],
      ['area-all', 'WK-HA12', 'WK-HA12', '上,下', 'WK-HA12'],
      ['area-all', 'WK-HA13', 'WK-HA13', '上,下', 'WK-HA13'],
      ['area-all', 'WK-N01', 'WK-N01', '上,下', 'WK-N01'],
      ['area-all', 'WK-N02', 'WK-N02', '上,下', 'WK-N02'],
      ['area-all', 'WK-N03', 'WK-N03', '上,下', 'WK-N03'],
      ['area-all', 'WK-N04', 'WK-N04', '上,下', 'WK-N04'],
      ['area-all', 'WK-N05', 'WK-N05', '上,下', 'WK-N05'],
      ['area-all', 'WK-S01', 'WK-S01', '上,下', 'WK-S01'],
      ['area-all', 'WK-S02', 'WK-S02', '上,下', 'WK-S02'],
      ['area-all', 'WK-S03', 'WK-S03', '上,下', 'WK-S03'],
      ['area-all', 'WK-S04', 'WK-S04', '上,下', 'WK-S04'],
      ['area-all', 'WK-S05', 'WK-S05', '上,下', 'WK-S05'],
      ['area-all', 'KS-RWY', 'KS-RWY', '上,下', 'KS-RWY'],
      ['area-all', 'KS-P01', 'KS-P01', '上,下', 'KS-P01'],
      ['area-all', 'KS-P02', 'KS-P02', '上,下', 'KS-P02'],
      ['area-all', 'KS-P03', 'KS-P03', '上,下', 'KS-P03'],
      ['area-all', 'KS-P04', 'KS-P04', '上,下', 'KS-P04'],
      ['area-all', 'KS-P05', 'KS-P05', '上,下', 'KS-P05'],
      ['area-all', 'KS-P06', 'KS-P06', '上,下', 'KS-P06'],
      ['area-all', 'KS-T01', 'KS-T01', '上,下', 'KS-T01'],
      ['area-all', 'KS-T02', 'KS-T02', '上,下', 'KS-T02'],
      ['area-all', 'KS-T03', 'KS-T03', '上,下', 'KS-T03'],
      ['area-all', 'KS-T04', 'KS-T04', '上,下', 'KS-T04'],
      ['area-all', 'KS-T05', 'KS-T05', '上,下', 'KS-T05'],
      ['area-all', 'KS-T06', 'KS-T06', '上,下', 'KS-T06'],
      ['area-all', 'KS-T07', 'KS-T07', '上,下', 'KS-T07'],
      ['area-all', 'KS-AP01', 'KS-AP01', '上,下', 'KS-AP01'],
      ['area-all', 'KS-AP02', 'KS-AP02', '上,下', 'KS-AP02'],
      ['area-all', 'KS-AP03', 'KS-AP03', '上,下', 'KS-AP03'],
      ['area-all', 'KS-AP05', 'KS-AP05', '上,下', 'KS-AP05'],
      ['area-all', 'KS-AP06', 'KS-AP06', '上,下', 'KS-AP06'],
      ['area-all', 'KS-AP07', 'KS-AP07', '上,下', 'KS-AP07'],
      ['area-all', 'KS-AP08', 'KS-AP08', '上,下', 'KS-AP08'],
      ['area-all', 'KS-HA01', 'KS-HA01', '上,下', 'KS-HA01'],
      ['area-all', 'KS-HA02', 'KS-HA02', '上,下', 'KS-HA02'],
      ['area-all', 'KS-HA03', 'KS-HA03', '上,下', 'KS-HA03'],
      ['area-all', 'KS-HA04', 'KS-HA04', '上,下', 'KS-HA04'],
      ['area-all', 'KS-HA05', 'KS-HA05', '上,下', 'KS-HA05'],
      ['area-all', 'KS-HA06', 'KS-HA06', '上,下', 'KS-HA06'],
      ['area-all', 'KS-HA07', 'KS-HA07', '上,下', 'KS-HA07'],
      ['area-all', 'KS-HA08', 'KS-HA08', '上,下', 'KS-HA08'],
      ['area-all', 'KS-HA09', 'KS-HA09', '上,下', 'KS-HA09'],
      ['area-all', 'KS-HA10', 'KS-HA10', '上,下', 'KS-HA10'],
      ['area-all', 'KS-HA11', 'KS-HA11', '上,下', 'KS-HA11'],
      ['area-all', 'KS-HA12', 'KS-HA12', '上,下', 'KS-HA12'],
      ['area-all', 'KS-N01', 'KS-N01', '上,下', 'KS-N01'],
      ['area-all', 'KS-N02', 'KS-N02', '上,下', 'KS-N02'],
      ['area-all', 'KS-N03', 'KS-N03', '上,下', 'KS-N03'],
      ['area-all', 'KS-N04', 'KS-N04', '上,下', 'KS-N04'],
      ['area-all', 'KS-N05', 'KS-N05', '上,下', 'KS-N05'],
      ['area-all', 'KS-N06', 'KS-N06', '上,下', 'KS-N06'],
      ['area-all', 'KS-N07', 'KS-N07', '上,下', 'KS-N07'],
      ['area-all', 'KS-N08', 'KS-N08', '上,下', 'KS-N08'],
      ['area-all', 'KS-N09', 'KS-N09', '上,下', 'KS-N09'],
      ['area-all', 'KS-N10', 'KS-N10', '上,下', 'KS-N10'],
      ['area-all', 'KS-N11', 'KS-N11', '上,下', 'KS-N11'],
      ['area-all', 'KS-N12', 'KS-N12', '上,下', 'KS-N12'],
      ['area-all', 'KS-N13', 'KS-N13', '上,下', 'KS-N13'],
      ['area-all', 'KS-N14', 'KS-N14', '上,下', 'KS-N14'],
      ['area-all', 'KS-N15', 'KS-N15', '上,下', 'KS-N15'],
      ['area-all', 'KS-N16', 'KS-N16', '上,下', 'KS-N16'],
      ['area-all', 'KS-N17', 'KS-N17', '上,下', 'KS-N17'],
      ['area-all', 'KS-N18', 'KS-N18', '上,下', 'KS-N18'],
      ['area-all', 'KS-N19', 'KS-N19', '上,下', 'KS-N19'],
      ['area-all', 'KS-N20', 'KS-N20', '上,下', 'KS-N20'],
      ['area-all', 'KS-N21', 'KS-N21', '上,下', 'KS-N21'],
      ['area-all', 'KS-N22', 'KS-N22', '上,下', 'KS-N22'],
      ['area-all', 'KS-N23', 'KS-N23', '上,下', 'KS-N23'],
      ['area-all', 'KS-S01', 'KS-S01', '上,下', 'KS-S01'],
      ['area-all', 'KS-S02', 'KS-S02', '上,下', 'KS-S02'],
      ['area-all', 'KS-S03', 'KS-S03', '上,下', 'KS-S03'],
      ['area-all', 'KS-K01', 'KS-K01', '上,下', 'KS-K01'],
      ['area-all', 'KS-K02', 'KS-K02', '上,下', 'KS-K02'],
      ['area-all', 'KS-K03', 'KS-K03', '上,下', 'KS-K03'],
      ['area-all', 'KS-K04', 'KS-K04', '上,下', 'KS-K04'],
      ['area-all', 'KS-K05', 'KS-K05', '上,下', 'KS-K05'],
      ['area-all', 'KS-K06', 'KS-K06', '上,下', 'KS-K06'],
      ['area-all', 'OB-RWY', 'OB-RWY', '上,下', 'OB-RWY'],
      ['area-all', 'OB-P01', 'OB-P01', '上,下', 'OB-P01'],
      ['area-all', 'OB-P02', 'OB-P02', '上,下', 'OB-P02'],
      ['area-all', 'OB-P03', 'OB-P03', '上,下', 'OB-P03'],
      ['area-all', 'OB-P04', 'OB-P04', '上,下', 'OB-P04'],
      ['area-all', 'OB-T01', 'OB-T01', '上,下', 'OB-T01'],
      ['area-all', 'OB-T02', 'OB-T02', '上,下', 'OB-T02'],
      ['area-all', 'OB-T03', 'OB-T03', '上,下', 'OB-T03'],
      ['area-all', 'OB-T04', 'OB-T04', '上,下', 'OB-T04'],
      ['area-all', 'OB-T05', 'OB-T05', '上,下', 'OB-T05'],
      ['area-all', 'OB-B01', 'OB-B01', '上,下', 'OB-B01'],
      ['area-all', 'OB-B02', 'OB-B02', '上,下', 'OB-B02'],
      ['area-all', 'OB-D01', 'OB-D01', '上,下', 'OB-D01'],
      ['area-all', 'OB-AP01', 'OB-AP01', '上,下', 'OB-AP01'],
      ['area-all', 'OB-AP02', 'OB-AP02', '上,下', 'OB-AP02'],
      ['area-all', 'OB-AP03', 'OB-AP03', '上,下', 'OB-AP03'],
      ['area-all', 'OB-AP05', 'OB-AP05', '上,下', 'OB-AP05'],
      ['area-all', 'OB-AP06', 'OB-AP06', '上,下', 'OB-AP06'],
      ['area-all', 'OB-AP07', 'OB-AP07', '上,下', 'OB-AP07'],
      ['area-all', 'OB-AP08', 'OB-AP08', '上,下', 'OB-AP08'],
      ['area-all', 'OB-AP09', 'OB-AP09', '上,下', 'OB-AP09'],
      ['area-all', 'OB-AP10', 'OB-AP10', '上,下', 'OB-AP10'],
      ['area-all', 'OB-AP11', 'OB-AP11', '上,下', 'OB-AP11'],
      ['area-all', 'OB-AP12', 'OB-AP12', '上,下', 'OB-AP12'],
      ['area-all', 'OB-N01', 'OB-N01', '上,下', 'OB-N01'],
      ['area-all', 'OB-N02', 'OB-N02', '上,下', 'OB-N02'],
      ['area-all', 'OB-N03', 'OB-N03', '上,下', 'OB-N03'],
      ['area-all', 'OB-N04', 'OB-N04', '上,下', 'OB-N04'],
      ['area-all', 'OB-N05', 'OB-N05', '上,下', 'OB-N05'],
      ['area-all', 'OB-N06', 'OB-N06', '上,下', 'OB-N06'],
      ['area-all', 'OB-N07', 'OB-N07', '上,下', 'OB-N07'],
      ['area-all', 'OB-N08', 'OB-N08', '上,下', 'OB-N08'],
      ['area-all', 'OB-N09', 'OB-N09', '上,下', 'OB-N09'],
      ['area-all', 'OB-N10', 'OB-N10', '上,下', 'OB-N10'],
      ['area-all', 'OB-N11', 'OB-N11', '上,下', 'OB-N11'],
      ['area-all', 'OB-N12', 'OB-N12', '上,下', 'OB-N12'],
      ['area-all', 'OB-N13', 'OB-N13', '上,下', 'OB-N13'],
      ['area-all', 'OB-N14', 'OB-N14', '上,下', 'OB-N14'],
      ['area-all', 'OB-N15', 'OB-N15', '上,下', 'OB-N15'],
      ['area-all', 'OB-N16', 'OB-N16', '上,下', 'OB-N16'],
      ['area-all', 'OB-N17', 'OB-N17', '上,下', 'OB-N17'],
      ['area-all', 'OB-S01', 'OB-S01', '上,下', 'OB-S01'],
      ['area-all', 'OB-S02', 'OB-S02', '上,下', 'OB-S02'],
      ['area-all', 'OB-K01', 'OB-K01', '上,下', 'OB-K01'],
      ['area-all', 'OB-K02', 'OB-K02', '上,下', 'OB-K02'],
      ['area-all', 'OB-K03', 'OB-K03', '上,下', 'OB-K03'],
      ['area-all', 'OB-K04', 'OB-K04', '上,下', 'OB-K04'],
      ['area-all', 'OB-K05', 'OB-K05', '上,下', 'OB-K05'],
      ['area-all', 'OB-K06', 'OB-K06', '上,下', 'OB-K06'],
      ['area-all', 'HD-RWY', 'HD-RWY', '上,下', 'HD-RWY'],
      ['area-all', 'HD-P01', 'HD-P01', '上,下', 'HD-P01'],
      ['area-all', 'HD-P02', 'HD-P02', '上,下', 'HD-P02'],
      ['area-all', 'HD-P03', 'HD-P03', '上,下', 'HD-P03'],
      ['area-all', 'HD-P04', 'HD-P04', '上,下', 'HD-P04'],
      ['area-all', 'HD-P05', 'HD-P05', '上,下', 'HD-P05'],
      ['area-all', 'HD-P06', 'HD-P06', '上,下', 'HD-P06'],
      ['area-all', 'HD-T01', 'HD-T01', '上,下', 'HD-T01'],
      ['area-all', 'HD-T02', 'HD-T02', '上,下', 'HD-T02'],
      ['area-all', 'HD-T03', 'HD-T03', '上,下', 'HD-T03'],
      ['area-all', 'HD-T04', 'HD-T04', '上,下', 'HD-T04'],
      ['area-all', 'HD-T05', 'HD-T05', '上,下', 'HD-T05'],
      ['area-all', 'HD-T06', 'HD-T06', '上,下', 'HD-T06'],
      ['area-all', 'HD-T07', 'HD-T07', '上,下', 'HD-T07'],
      ['area-all', 'HD-AP01', 'HD-AP01', '上,下', 'HD-AP01'],
      ['area-all', 'HD-AP02', 'HD-AP02', '上,下', 'HD-AP02'],
      ['area-all', 'HD-AP03', 'HD-AP03', '上,下', 'HD-AP03'],
      ['area-all', 'HD-AP04', 'HD-AP04', '上,下', 'HD-AP04'],
      ['area-all', 'HD-AP05', 'HD-AP05', '上,下', 'HD-AP05'],
      ['area-all', 'HD-AP06', 'HD-AP06', '上,下', 'HD-AP06'],
      ['area-all', 'HD-AP07', 'HD-AP07', '上,下', 'HD-AP07'],
      ['area-all', 'HD-AP08', 'HD-AP08', '上,下', 'HD-AP08'],
      ['area-all', 'HD-AP09', 'HD-AP09', '上,下', 'HD-AP09'],
      ['area-all', 'HD-AP10', 'HD-AP10', '上,下', 'HD-AP10'],
      ['area-all', 'HD-HA01', 'HD-HA01', '上,下', 'HD-HA01'],
      ['area-all', 'HD-HA02', 'HD-HA02', '上,下', 'HD-HA02'],
      ['area-all', 'HD-HA03', 'HD-HA03', '上,下', 'HD-HA03'],
      ['area-all', 'HD-HA04', 'HD-HA04', '上,下', 'HD-HA04'],
      ['area-all', 'HD-HA05', 'HD-HA05', '上,下', 'HD-HA05'],
      ['area-all', 'HD-HA06', 'HD-HA06', '上,下', 'HD-HA06'],
      ['area-all', 'HD-HA07', 'HD-HA07', '上,下', 'HD-HA07'],
      ['area-all', 'HD-HA08', 'HD-HA08', '上,下', 'HD-HA08'],
      ['area-all', 'HD-HA09', 'HD-HA09', '上,下', 'HD-HA09'],
      ['area-all', 'HD-HA10', 'HD-HA10', '上,下', 'HD-HA10'],
      ['area-all', 'HD-HA11', 'HD-HA11', '上,下', 'HD-HA11'],
      ['area-all', 'HD-HA12', 'HD-HA12', '上,下', 'HD-HA12'],
      ['area-all', 'HD-HA13', 'HD-HA13', '上,下', 'HD-HA13'],
      ['area-all', 'HD-HA14', 'HD-HA14', '上,下', 'HD-HA14'],
      ['area-all', 'HD-HA15', 'HD-HA15', '上,下', 'HD-HA15'],
      ['area-all', 'HD-HA16', 'HD-HA16', '上,下', 'HD-HA16'],
      ['area-all', 'HD-N01', 'HD-N01', '上,下', 'HD-N01'],
      ['area-all', 'HD-N02', 'HD-N02', '上,下', 'HD-N02'],
      ['area-all', 'HD-N03', 'HD-N03', '上,下', 'HD-N03'],
      ['area-all', 'HD-N04', 'HD-N04', '上,下', 'HD-N04'],
      ['area-all', 'HD-N05', 'HD-N05', '上,下', 'HD-N05'],
      ['area-all', 'HD-J01', 'HD-J01', '上,下', 'HD-J01'],
      ['area-all', 'HD-K01', 'HD-K01', '上,下', 'HD-K01'],
      ['area-all', 'HD-K02', 'HD-K02', '上,下', 'HD-K02'],
      ['area-all', 'HD-K03', 'HD-K03', '上,下', 'HD-K03'],
      ['area-all', 'HD-K04', 'HD-K04', '上,下', 'HD-K04'],
      ['area-all', 'HD-K05', 'HD-K05', '上,下', 'HD-K05'],
    ];
    const ret: RoadNameDirectionMix[] = [];
    srcArr.forEach(e => {
      if (e[0].indexOf('dummy') !== 0) {
        const area = e[0];
        const roadName = e[1];
        const roadNameDisp = e[2];
        const roadNameReal = e[4];
        const directions = e[3].split(',').map(e => {
          return {
            direction: e,
            selected: false,
          };
        });
        ret.push({
          area,
          roadName,
          roadNameDisp,
          roadNameReal,
          directions,
          isDummy: false,
        });
      } else {
        ret.push({
          key: e[0],
          disp: e[1],
          isDummy: true,
        });
      }
    });
    return ret;
  }
  get getRoadNameDirections_nagano() {
    const srcArr = [
      ['area-all', 'E52', 'E52', '上,下', 'E52-0.0-780.0'],
    ];
    const ret: RoadNameDirectionMix[] = [];
    srcArr.forEach(e => {
      if (e[0].indexOf('dummy') !== 0) {
        const area = e[0];
        const roadName = e[1];
        const roadNameDisp = e[2];
        const roadNameReal = e[4];
        const directions = e[3].split(',').map(e => {
          return {
            direction: e,
            selected: false,
          };
        });
        ret.push({
          area,
          roadName,
          roadNameDisp,
          roadNameReal,
          directions,
          isDummy: false,
        });
      } else {
        ret.push({
          key: e[0],
          disp: e[1],
          isDummy: true,
        });
      }
    });
    return ret;
  }
  get getRoadNameDirections_default() {
    return [];
  }
}

export function getRoadNameDirections_(kpSetName: string): RoadNameDirectionMix[] {
  const funcName = 'getRoadNameDirections_' + kpSetName;
  const service = new RoadNameDirectionsService();
  return getVal(service, funcName, 'getRoadNameDirections_default');
}

class RoadNameDirectionShortcutsService {
  get getRoadNameDirectionShortcuts_shutokou() {
    return [
      {
        key: 'area',
        label: 'エリア',
        arr: [
          { name: '西', key: 't-west' },
          { name: '東', key: 't-east' },
          { name: '神', key: 'kanagawa' },
        ],
      },
      {
        key: 'direction',
        label: '方向',
        arr: [
          { name: '上', key: '上' },
          { name: '南', key: '南' },
          { name: '西', key: '西' },
          { name: '内', key: '内' },
          { name: '下', key: '下' },
          { name: '北', key: '北' },
          { name: '東', key: '東' },
          { name: '外', key: '外' },
        ],
      },
    ];
  }
  get getRoadNameDirectionShortcuts_hokuriku() {
    return [
      {
        key: 'area',
        label: 'エリア',
        arr: [
          { name: '全て', key: 'area-all' },
        ],
      },
      {
        key: 'direction',
        label: '方向',
        arr: [
          { name: '上', key: '上' },
          { name: '下', key: '下' },
        ],
      },
    ];
  }
  get getRoadNameDirectionShortcuts_arc() {
    return [
      {
        key: 'area',
        label: 'エリア',
        arr: [
          { name: '全て', key: 'area-all' },
        ],
      },
      {
        key: 'direction',
        label: '方向',
        arr: [
          { name: '上', key: '上' },
          { name: '下', key: '下' },
        ],
      },
    ];
  }
  get getRoadNameDirectionShortcuts_shikoku() {
    return [
      {
        key: 'area',
        label: 'エリア',
        arr: [
          { name: '全て', key: 'area-all' },
        ],
      },
      {
        key: 'direction',
        label: '方向',
        arr: [
          { name: '上', key: '上' },
          { name: '下', key: '下' },
        ],
      },
    ];
  }
  get getRoadNameDirectionShortcuts_fukuoka_kitakyushu() {
    return [
      {
        key: 'area',
        label: 'エリア',
        arr: [
          { name: '全て', key: 'area-all' },
        ],
      },
      {
        key: 'direction',
        label: '方向',
        arr: [
          { name: '上', key: '上' },
          { name: '下', key: '下' },
        ],
      },
    ];
  }
  get getRoadNameDirectionShortcuts_hiroshima_airport() {
    return [
      {
        key: 'area',
        label: 'エリア',
        arr: [
          { name: '全て', key: 'area-all' },
        ],
      },
      {
        key: 'direction',
        label: '方向',
        arr: [
          { name: '南', key: '南' },
          { name: '西', key: '西' },
          { name: '北', key: '北' },
          { name: '東', key: '東' },
        ],
      },
    ];
  }
  get getRoadNameDirectionShortcuts_shinchitose_airport() {
    return [
      {
        key: 'area',
        label: 'エリア',
        arr: [
          { name: '全て', key: 'area-all' },
        ],
      },
      {
        key: 'direction',
        label: '方向',
        arr: [
          { name: '上', key: '上' },
          { name: '下', key: '下' },
        ],
      },
    ];
  }
  get getRoadNameDirectionShortcuts_nagano() {
    return [
      {
        key: 'area',
        label: 'エリア',
        arr: [
          { name: '全て', key: 'area-all' },
        ],
      },
      {
        key: 'direction',
        label: '方向',
        arr: [
          { name: '上', key: '上' },
          { name: '下', key: '下' },
        ],
      },
    ];
  }
  get getRoadNameDirectionShortcuts_default() {
    return [];
  }
}
export function getRoadNameDirectionShortcuts_(kpSetName: string): RoadNameDirectionShortcut[] {
  const funcName = 'getRoadNameDirectionShortcuts_' + kpSetName;
  const service = new RoadNameDirectionShortcutsService();
  return getVal(service, funcName, 'getRoadNameDirectionShortcuts_default');
}

class RoadNameIgnoresService {
  get getRoadNameIgnores_default() {
    return [];
  }

  get getRoadNameIgnores_shutokou() {
    return [
      '高速神奈川6号川崎線-大師JCT(A)',
      '高速神奈川6号川崎線-大師JCT(B)',
      '高速神奈川6号川崎線-大師JCT(C)',
      '高速神奈川6号川崎線-大師JCT(D)',
      '高速神奈川6号川崎線-大師JCT(E)',
      '高速神奈川6号川崎線-大師JCT(F)',
      '高速神奈川7号横浜北西線-青葉JCT(K)',
      '高速神奈川7号横浜北西線-青葉JCT(L)',
      '高速神奈川7号横浜北西線-青葉JCT(M)',
      '高速神奈川7号横浜北西線-青葉JCT(N)',
      '高速神奈川7号横浜北西線-青葉JCT(O)',
      '高速神奈川7号横浜北西線-青葉JCT(P)',
    ];
  }
}

export function getRoadNameIgnores_(kpSetName: string): string[] {
  // 路線別画面用.
  // 実際はJCTや出入口だがデータ上は本線扱いとなっている路線名の配列.
  const funcName = 'getRoadNameIgnores_' + kpSetName;
  const service = new RoadNameIgnoresService();
  return getVal(service, funcName, 'getRoadNameIgnores_default');
}

export function isKpIncreaseDirection(roadName: string, direction: string): boolean {
  if (roadName === '高速10号晴海線') {
    // 晴海線は例外として下方向でKPが減少、上方向でKPが増加する.
    return !_isKpIncreaseDirection(direction);
  }
  if (roadName === '高速神奈川5号大黒線') {
    // 大黒線は例外として下方向でKPが減少、上方向でKPが増加する.
    return !_isKpIncreaseDirection(direction);
  }
  return _isKpIncreaseDirection(direction);
}

export function _isKpIncreaseDirection(direction: string): boolean {
  const set = new Set(['下', '南', '西', '外']);
  return set.has(direction);
}
